import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-view-img-dialog',
  templateUrl: './view-img-dialog.component.html',
  styleUrls: ['./view-img-dialog.component.scss'],
})
export class ViewImgDialogComponent {
  imgSrclUrl: string;

  constructor(
    public dialogRef: MatDialogRef<ViewImgDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewImgDialogModel
  ) {
    this.imgSrclUrl = data.imgSrclUrl;
  }

  onOpen(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class ViewImgDialogModel {
  constructor(public imgSrclUrl: string) {}
}
